import { REDO_COMMAND, UNDO_COMMAND } from 'lexical';
import React from 'react';
import { KeyValueMap } from '../KeyValueMap';
import { ActionType } from '../components/ActionType';
import ResponsiveToolbar from '../components/ResponsiveToolbar';
import { Icons } from '../icons/Icons';

export const undoRedo = (editor): KeyValueMap<string, ActionType> => {
    return {
        undo: {
            label: 'lexical.format.undo',
            icon: Icons.Undo,
            onClick: () => {
                editor.dispatchCommand(UNDO_COMMAND, undefined);
            }
        },
        redo: {
            label: 'lexical.format.redo',
            icon: Icons.Redo,
            onClick: () => {
                editor.dispatchCommand(REDO_COMMAND, undefined);
            }
        }
    };
};

export default ({ editor, disabled }) => {
    return <ResponsiveToolbar disabled={disabled} multi={false} isSmall={false} options={undoRedo(editor)} />;
};
